export const UPLOADLOGS = {
  CAPITALLOANS_FOLDER:
    {
      TRUSTDEEDS: 'LoanTrustDeeds',
      LOANPACK: 'LoanPack',
      AMOUNTCONFIRMATION: 'LoanAmountConfirmation',
    },
  CAPITALLOANS_HEADER:
    {
      TRUSTDEEDS: 'Loan Trust Deeds',
      LOANPACK: 'Loan Pack',
      AMOUNTCONFIRMATION: 'Loan Amount Confirmation',
    },
}



// WEBPACK FOOTER //
// ./src/constants/uploadlogs.js